import { render } from "./widget-uzel-ucheta.vue?vue&type=template&id=9327e510"
import script from "./widget-uzel-ucheta.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-uzel-ucheta.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-grid/components/widgets/widget-uzel-ucheta.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9327e510"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9327e510', __exports__)) {
    api.reload('9327e510', __exports__)
  }
  
  module.hot.accept("./widget-uzel-ucheta.vue?vue&type=template&id=9327e510", () => {
    api.rerender('9327e510', render)
  })

}


export default __exports__